import { Grid, List, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useRef } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const EventVideosComponent = ({
	onDragEnd,
	id,
	ListItem,
	ListContainer = List,
	list
}) => {
	const sortListContainer = useRef(null);
	const classes = useStyles();

	const _onDragEnd = (result) => {
		if (!result.destination) {
			return result;
		}
		const items = reorder(list, result.source.index, result.destination.index);
		onDragEnd(items);
	};

	return (
		<DragDropContext onDragEnd={_onDragEnd}>
			<Droppable droppableId={id}>
				{(provided) => (
					<Paper
						ref={sortListContainer}
						style={{
							minHeight: sortListContainer?.current?.clientHeight
						}}
					>
						<Grid container spacing={1} className={classes.root}>
							<Grid item md={2} xs={12}>
								{''}
							</Grid>
							<Grid item md={3} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
									sx={{ textAlign: 'center' }}
								>
									{'Video Title'}
								</Typography>
							</Grid>

							<Grid item md={6} xs={12}>
								<Typography
									variant="body1"
									color={'primary'}
									className={classes.text}
									sx={{ textAlign: 'center' }}
								>
									{'Video'}
								</Typography>
							</Grid>
							<Grid item md={1} xs={12}>
								{' '}
							</Grid>
						</Grid>
						<ListContainer {...provided.droppableProps} ref={provided.innerRef}>
							{list.map((item, index) => (
								<Draggable
									key={item.id}
									draggableId={item.id.toString()}
									index={index}
								>
									{(provided, snapshot) => (
										<div
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
											style={getItemStyle(
												snapshot.isDragging,
												provided.draggableProps.style
											)}
										>
											<ListItem key={item.id} item={item} index={index} />
										</div>
									)}
								</Draggable>
							))}
							{list.length < 1 && (
								<Typography
									variant="body2"
									color="textSecondary"
									align="center"
									sx={{ padding: 2 }}
								>
									No videos available
								</Typography>
							)}

							{provided.placeholder}
						</ListContainer>
					</Paper>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default EventVideosComponent;

const getItemStyle = (_, draggableStyle) => ({
	userSelect: 'none',
	...draggableStyle
});

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result.map((item, index) => ({
		...item,
		position: index + 1
	}));
};

const useStyles = makeStyles((theme) => ({
	root: {
		padding: 20
	},
	item: { verticalAlign: 'center' },
	text: { paddingTop: 20 },
	icon: { color: '#757575', marginLeft: 20, marginTop: 20 },
	button: { paddingTop: 20 }
}));
